var _path, _ellipse, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgShopping1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1920,
    height: 1080,
    viewBox: "0 0 1920 1080",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M943 130L943 158",
    stroke: "#F2DCCE",
    strokeWidth: 2
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 943.5,
    cy: 125.333,
    rx: 16.5,
    ry: 16.3333,
    fill: "#F2DCCE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M940.105 134C939.637 134 939.236 133.834 938.903 133.501C938.57 133.168 938.403 132.768 938.403 132.3C938.403 131.833 938.57 131.432 938.903 131.099C939.236 130.766 939.637 130.6 940.105 130.6C940.573 130.6 940.973 130.766 941.306 131.099C941.64 131.432 941.806 131.833 941.806 132.3C941.806 132.768 941.64 133.168 941.306 133.501C940.973 133.834 940.573 134 940.105 134ZM948.613 134C948.145 134 947.744 133.834 947.411 133.501C947.078 133.168 946.911 132.768 946.911 132.3C946.911 131.833 947.078 131.432 947.411 131.099C947.744 130.766 948.145 130.6 948.613 130.6C949.081 130.6 949.481 130.766 949.814 131.099C950.148 131.432 950.314 131.833 950.314 132.3C950.314 132.768 950.148 133.168 949.814 133.501C949.481 133.834 949.081 134 948.613 134ZM939.382 120.4L941.423 124.65H947.379L949.719 120.4H939.382ZM938.573 118.7H951.122C951.449 118.7 951.697 118.845 951.867 119.136C952.037 119.426 952.044 119.72 951.888 120.018L948.868 125.457C948.712 125.741 948.503 125.96 948.24 126.116C947.978 126.272 947.691 126.35 947.379 126.35H941.041L940.105 128.05H950.314V129.75H940.105C939.467 129.75 938.985 129.47 938.658 128.911C938.332 128.351 938.318 127.795 938.616 127.242L939.764 125.16L936.702 118.7H935V117H937.765L938.573 118.7Z",
    fill: "#CC7D61"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShopping1);
export default __webpack_public_path__ + "static/media/shopping_1.dac549d92f0edde73e456f84f1509438.svg";
export { ForwardRef as ReactComponent };